
import request from "@/API/request";
// 新增会话
export function sendMessage(data) {
    return request({
        url: `/auth/api/customer-service/customer/message`,
        method: 'post',
        data
    });
}
// 结束会话
export function closeMessage(params) {
    return request({
        url: `/auth/api/customer-service/session/end`,
        method: 'post',
        params: params
    });
}
